import axiosService from './axios.service';
import ResponseService from './response.service';

const getDashboardData = async (_formData) => {
  try {
    let _axiosData = {
      method: 'get',
      url: 'dashboard',
      isAuthorized: true,
      formData: _formData,
    };

    const response = await axiosService.hit(_axiosData);
    return response.data;
  } catch (error) {
    return ResponseService.buildFailure(error.message);
  }
};

const DashboardService = {
  getDashboardData,
};

export default DashboardService;
